export enum MoveDirection {
  ToTopBlock = 'toTopBlock',
  ToTop = 'toTop',
  UpOneBlock = 'upOneBlock',
  Up = 'up',
  Down = 'down',
  DownOneBlock = 'downOneBlock',
  ToBottom = 'toBottom',
  ToBottomBlock = 'toBottomBlock',
}
